module.exports = __webpack_public_path__ + "fc526450f9f00386250205ca1597058b.MP3";